// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectedFile[data-v-fd6e43ae]{border:2px solid #f90}.demo-spin-icon-load[data-v-fd6e43ae]{animation:ani-demo-spin-fd6e43ae 1s linear infinite}@keyframes ani-demo-spin-fd6e43ae{0%{transform:rotate(0deg)}50%{transform:rotate(180deg)}to{transform:rotate(1turn)}}.demo-spin-col[data-v-fd6e43ae]{height:100px;position:relative;border:1px solid #eee}", ""]);
// Exports
module.exports = exports;
